// Readlume theme scripts — minimal, dependency free.

(function () {
  // Mobile nav
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product gallery
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) {
          main.src = btn.getAttribute('data-src');
          main.alt = btn.getAttribute('data-alt') || '';
        }
      });
    });
  });

  // Variant selection
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var select = form.querySelector('[data-variant-select]');
    var priceEl = document.querySelector('[data-variant-price]');
    var submit = form.querySelector('[data-add-to-cart]');
    if (!select) return;

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var available = option.getAttribute('data-available') === 'true';
      if (priceEl) priceEl.textContent = option.getAttribute('data-price') || priceEl.textContent;
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? submit.getAttribute('data-label') : 'Unavailable';
      }
    });
  });

  // Add to cart with inline errors (keeps mobile users unstuck)
  document.querySelectorAll('[data-ajax-cart]').forEach(function (form) {
    var alertEl = form.querySelector('[data-form-alert]');
    var button = form.querySelector('[type="submit"]');

    function showError(message) {
      if (!alertEl) {
        window.alert(message);
        return;
      }
      alertEl.hidden = false;
      alertEl.textContent = message;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (alertEl) alertEl.hidden = true;

      var data = new FormData(form);
      var original = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding…';
      }

      fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.description || body.message || 'We could not add this item. Please try again.');
            return body;
          });
        })
        .then(function () {
          if (form.getAttribute('data-redirect') === 'checkout') {
            window.location.href = '/checkout';
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (error) {
          showError(error.message);
          if (button) {
            button.disabled = false;
            button.textContent = original;
          }
        });
    });
  });
})();
